<template>
  <div>
    <div v-for="(item, index) in items" v-bind:key="index">
      <div class="input-group mb-1" :class="[sizeVal]">
        <div class="input-group-prepend" v-if="showIndex">
          <span class="input-group-text">
            {{index+1}}
            <span v-if="m">/{{m}}</span>
          </span>
        </div>
        <input
          type="number"
          class="form-control"
          v-model.number="items[index][0]"
          :readonly="disabled"
          :placeholder="placeholderMin"
          step="0.01"
          style="max-width: 100px"
        >
        <input
          type="number"
          class="form-control"
          v-model.number="items[index][1]"
          :readonly="disabled"
          :placeholder="placeholderMax"
          step="0.01"
          style="max-width: 100px"
        >
        <input
          type="text"
          class="form-control"
          v-model="items[index][2]"
          :readonly="disabled"
          :placeholder="placeholderRule"
        >
        <div class="input-group-append" v-if="!disabled || !required">
          <span class="input-group-text pt" @click="deleteItem(index)" :title="deleteTooltip">x</span>
        </div>
      </div>
    </div>
    <b-button
      type="button"
      variant="brand"
      class="btn-sm mt-1"
      @click="addItem()"
      v-if="!disabled || !required"
    >{{addLabel}}</b-button>
  </div>
</template>

<script>
export default {
  name: "TaxationLadderEditor",
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    },
    addLabel: {
      type: String,
      default: () => "Add New Item"
    },
    deleteTooltip: {
      type: String,
      default: () => "Delete Item"
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    showIndex: {
      type: Boolean,
      default: () => false
    },
    m: {
      type: String,
      default: () => ""
    },
    required: {
      type: Boolean,
      default: () => false
    },
    placeholderMin: {
      type: String,
      default: () => ""
    },
    placeholderMax: {
      type: String,
      default: () => ""
    },
    placeholderRule: {
      type: String,
      default: () => ""
    },
    size: {
      type: String,
      default: ""
    }
  },
  computed: {
    sizeVal() {
      return this.size ? `input-group-${this.size}` : "";
    }
  },
  methods: {
    deleteItem(index) {
      this.items.splice(index, 1);
    },
    addItem(index) {
      this.items.push([null, null, ""]);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
